var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"from-from-trip-planner",attrs:{"text":""},on:{"click":_vm.tripPlannerToggle}},[_c('v-icon',{attrs:{"left":"","color":"secondary"}},[_vm._v("\n    mdi-close\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }